import { BaseContainerModel } from '../base-container.model';
import { bl_mrp_process_type_checklist_attachment_RowClass } from '../../dbschema/bl_mrp_process_type_checklist_attachment.model';

export class ProcessTypeFileContainerModel extends BaseContainerModel {
  bl_mrp_process_type_checklist_attachment: bl_mrp_process_type_checklist_attachment_RowClass = new bl_mrp_process_type_checklist_attachment_RowClass();
}
